import React from "react";

// Original path-drawn lettering: no font or third-party logo dependency.
const letters = {
  s: "M19 24C14 19 3 20 3 27C3 34 19 31 19 39C19 46 7 48 2 42",
  u: "M3 22V37C3 50 20 48 20 37V22M20 37V46",
  d: "M21 8V46M21 34C21 17 2 18 2 34C2 50 21 50 21 34",
  l: "M6 8V39Q6 46 13 46",
  e: "M3 33H21C21 16 2 18 2 34C2 47 14 50 21 42",
  c: "M21 25C10 14 1 23 2 35C3 47 14 50 21 42",
  o: "M21 34C21 17 2 18 2 34C2 51 21 51 21 34Z",
  r: "M3 46V22M3 33Q7 18 19 23",
  n: "M3 46V22M3 33C3 18 21 18 21 32V46",
};

export default function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 412 76" aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="3.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 23V5H23M47 5H65V23M65 52V70H47M23 70H4V52" />
        <path d="M47 23H29Q19 23 19 31Q19 38 30 38H39Q50 38 50 46Q50 54 39 54H22" strokeWidth="5.5" />
        <g transform="translate(84 2) skewX(-5)">
          {[..."suddlecorner"].map((letter, index) => (
            <path key={index} d={letters[letter]} transform={`translate(${index * 27} 0)`} />
          ))}
        </g>
        <path d="M83 62H400V54" strokeWidth="2" />
      </g>
    </svg>
  );
}
